import { europeanCountries } from '@/constant/european-countries';
import Script from 'next/script';
import React from 'react';
const GoogleAnalytics = () => {
  const generateConsentScript = () => {
    const countriesJSON = JSON.stringify(europeanCountries);
    return `
          (function() {
            window.dataLayer = window.dataLayer || [];
            function gtag() { window.dataLayer.push(arguments); }
            window.gtag = gtag;

            const waitForCookie = (cookieName, callback, maxRetries = 10, interval = 200) => {
              let retries = 0;
              let timeoutId;

              const checkCookie = () => {
                const cookieValue = document.cookie
                  .split('; ')
                  .find((row) => row.startsWith(cookieName + '='))
                  ?.split('=')[1];
                if (cookieValue) {
                  clearTimeout(timeoutId);
                  callback(cookieValue);
                } else if (retries < maxRetries) {
                  retries++;
                  timeoutId = setTimeout(checkCookie, interval);
                } 
              };

              checkCookie();
            };

            const initializeConsent = (countryCode) => {
              const countries = ${countriesJSON};
              const isEuropean = countryCode && countries.includes(countryCode);
              const storedConsentMode = localStorage?.getItem('consentMode');

              if (storedConsentMode) {
                gtag('consent', 'default', JSON.parse(storedConsentMode));
              } else {
                const defaultConsent = {
                  'ad_storage': isEuropean ? 'denied' : 'granted',
                  'analytics_storage': isEuropean ? 'denied' : 'granted',
                  'personalization_storage': isEuropean ? 'denied' : 'granted',
                  'functionality_storage': isEuropean ? 'denied' : 'granted',
                  'security_storage': isEuropean ? 'denied' : 'granted',
                  'ad_personalization': isEuropean ? 'denied' : 'granted',
                  'ad_user_data': isEuropean ? 'denied' : 'granted',
                };

                gtag('consent', 'default', defaultConsent);
                localStorage.setItem('consentMode', JSON.stringify(defaultConsent));
              }

              gtag('js', new Date());
            };

            try {
              waitForCookie('cf-ipcountry', initializeConsent);
            } catch (error) {
              console.error('Consent initialization failed:', error);
            }
          })();
        `;
  };
  const generateGTMScript = () => {
    return `
            (function(w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                const f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l !== 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.defer = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', '${process.env.NEXT_PUBLIC_G_ADDS_GTM_ID}');
        `;
  };
  return <>
            <Script id="gtag-consent-default" strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: generateConsentScript()
    }} data-sentry-element="Script" data-sentry-source-file="GoogleAnalytics.tsx" />

            <Script id="google-tag-manager" strategy="lazyOnload" defer dangerouslySetInnerHTML={{
      __html: generateGTMScript()
    }} data-sentry-element="Script" data-sentry-source-file="GoogleAnalytics.tsx" />
        </>;
};
export default GoogleAnalytics;